<template>
  <section class="section why-section" id="section-2">
    <div class="why-section-container wrapper">
      <h2 class="why-section-title title big weight-900">
        {{ $t("Why Buy a Private Island in Minecraft?") }}
      </h2>

      <div class="why-section-cards">
        <div class="why-card">
          <div class="desc desc-20">
            <b>{{ $t("Total Autonomy") }}</b>
          </div>
          <img
            src="@/assets/why-1.webp"
            alt="Why buy island 1"
            class="why-card-image"
          />
          <p class="why-card-text">
            {{
              $t(
                "Your land, your rules - no random builds and virtually zero griefing."
              )
            }}
          </p>
        </div>

        <div class="why-card">
          <div class="desc desc-20">
            <b>{{ $t("Create without Limits") }}</b>
          </div>
          <img
            src="@/assets/why-2.webp"
            alt="Why buy island 2"
            class="why-card-image"
          />
          <p class="why-card-text">
            {{
              $t(
                "Experiment with resources and terrain without worrying about other players’ plots."
              )
            }}
          </p>
        </div>

        <div class="why-card">
          <div class="desc desc-20">
            <b>{{ $t("Exclusive Perks") }}</b>
          </div>
          <img
            src="@/assets/why-3.webp"
            alt="Why buy island 3"
            class="why-card-image"
          />
          <p class="why-card-text">
            {{
              $t(
                "Islands owners get rare schematics, premium events, and priority support."
              )
            }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "WhyBuySection",
};
</script>

<style lang="scss" scoped>
.why-section {
  padding-top: 220px;
  padding-bottom: 360px;
  position: relative;

  &-title {
    text-align: center;
    max-width: 794px;
    margin: 0 auto;
  }

  &-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin: 110px auto 0;
  }
}

.why-card {
  background: #113a54cc;
  border-radius: 30px;
  backdrop-filter: blur(10px);
  padding: 30px 16px 34px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &-image {
    width: 180px;
    margin: 18px auto 16px;
  }

  &-text {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: white;
    max-width: 370px;
  }
}

@media (max-width: 1200px) {
  .why-section-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .why-section {
    padding-top: 0;
    padding-bottom: 40px;
    &-title {
      font-size: 48px;
      line-height: 60px;
    }

    &-subtitle {
      font-size: 24px;
      line-height: 30px;
      margin-bottom: 50px;
    }

    &-cards {
      grid-template-columns: 1fr;
      max-width: 500px;
    }
  }

  .why-card {
    padding: 30px 20px;
  }
}

@media (max-width: 480px) {
  .why-section {
    &-title {
      font-size: 36px;
      line-height: 45px;
    }
  }
}
</style>
